export type Language = {
	code: string
	name: string
	englishName: string
	flag: string
}

export const getLanguages = (): Language[] => {
	return [
		{ code: 'en', name: 'English', englishName: 'English', flag: 'gb' },
		{ code: 'es', name: 'Español', englishName: 'Spanish', flag: 'es' },
		{ code: 'fr', name: 'Français', englishName: 'French', flag: 'fr' },
		{ code: 'de', name: 'Deutsch', englishName: 'German', flag: 'de' },
		{ code: 'it', name: 'Italiano', englishName: 'Italian', flag: 'it' },
		{ code: 'pt', name: 'Português', englishName: 'Portuguese', flag: 'pt' },
		{ code: 'nl', name: 'Nederlands', englishName: 'Dutch', flag: 'nl' },
		{ code: 'sv', name: 'Svenska', englishName: 'Swedish', flag: 'se' },
		{ code: 'ro', name: 'Română', englishName: 'Romanian', flag: 'ro' },
		{ code: 'ar', name: 'العربية', englishName: 'Arabic', flag: 'sa' },
		{ code: 'he', name: 'עברית', englishName: 'Hebrew', flag: 'il' },
		{ code: 'tr', name: 'Türkçe', englishName: 'Turkish', flag: 'tr' },
		{ code: 'no', name: 'Norsk', englishName: 'Norwegian', flag: 'no' },
		{ code: 'pl', name: 'Polski', englishName: 'Polish', flag: 'pl' },
		{ code: 'hu', name: 'Magyar', englishName: 'Hungarian', flag: 'hu' },
		{ code: 'ru', name: 'Русский', englishName: 'Russian', flag: 'ru' },
		{ code: 'fi', name: 'Suomi', englishName: 'Finnish', flag: 'fi' },
		{ code: 'cz', name: 'Čeština', englishName: 'Czech', flag: 'cz' },
		{ code: 'gr', name: 'Ελληνικά', englishName: 'Greek', flag: 'gr' },
		{ code: 'th', name: 'ไทย', englishName: 'Thai', flag: 'th' },
		{ code: 'ko', name: '한국어', englishName: 'Korean', flag: 'kr' },
		{ code: 'zh', name: '繁體中文', englishName: 'Chinese (Traditional)', flag: 'tw' },
		{ code: 'ja', name: '日本語', englishName: 'Japanese', flag: 'jp' },
		{ code: 'vi', name: 'Tiếng Việt', englishName: 'Vietnamese', flag: 'vn' },
	]
}
